import { useState, useEffect } from 'react'; // Add this import at the top

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null); // Add user role state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate token validation
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('userRole'); // Retrieve role from localStorage

    console.log('useAuth: Checking authentication token:', token);
    console.log('useAuth: Checking user role:', role);

    if (token) {
      // Assume the token is valid for simplicity
      setIsAuthenticated(true);
      setUserRole(role); // Set role if available
    } else {
      setIsAuthenticated(false);
      setUserRole(null);
    }

    setLoading(false);
  }, []);

  const login = (token, role) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userRole', role); // Store role in localStorage
    setIsAuthenticated(true);
    setUserRole(role); // Set role on login
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole'); // Remove role from localStorage
    setIsAuthenticated(false);
    setUserRole(null); // Clear role on logout
  };

  return { isAuthenticated, userRole, loading, login, logout, setUserRole };
}
